export { default } from './SubregionForecastContentHighlights';
